import * as angular from "angular";

angular
  .module('bringoz.admin.wallets')
  .constant('WalletsBalances_PN', {
    database: 'walletBalance',
    isBranchEntity: false
  });
